import { useId } from 'react';

function useReactId() {
  const id = useId();
  return id ? `kohler-${id.replace(/:/g, "")}` : "";
}

export { useReactId };
